module.exports = "/_next/static/images/060dfb553f66731c09bd888e2246e4eb-ticket-02-01.png";